$( document ).ready(function() {

  $('.contactsticky_info').on('click', () => {
    $('.contactsticky_form').slideToggle()
  })
  $('.contactsticky_border').on('click', () => {
    $('.contactsticky_form').slideToggle()
  })
});